import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import SearchBar from '../../../components/utils/SearchBar'
import Table from '../../../components/utils/Table'
import { useDispatch, useSelector } from 'react-redux';
import { convertDateToRequiredFormatTZ } from '../../../helpers/commonFunction'
import LockedActivationActions from "../../../redux/lockedActivation/actions"
import Alert from '../../../components/utils/Alert';


const { getLockedDailyPlanActivation, releaseDailyPlanRequest, resetMessage } = LockedActivationActions

const DailyPlanRequest = () => {
    const dispatch = useDispatch();
    const [filterText, setFilterText] = useState("");
    const { lockedDailyPlanResult, realselockDailyPlanmessage, realselockDailyPlanerror, loading } = useSelector((state) => state.lockedActivation);
    const [showAlert, setShowAlert] = useState(false);
    const [alertType, setAlertType] = useState('');
    const [alertText, setAlertText] = useState('');
    const [releaselockloading, setReleaseLockLoading] = useState(null);


    useEffect(() => {
        dispatch(getLockedDailyPlanActivation());
    }, [])

    useEffect(() => {
        if (realselockDailyPlanmessage !== null && realselockDailyPlanmessage !== undefined) {
            displayAlert(realselockDailyPlanmessage, 'alert-success');
        }
        if (realselockDailyPlanerror !== null && realselockDailyPlanerror !== undefined) {
            displayAlert(realselockDailyPlanerror, 'alert-danger');
        }
    }, [realselockDailyPlanmessage, realselockDailyPlanerror]);

    const handleFilterChange = (value) => {
        setFilterText(value);
    };

    const handleUnlockDailyPlan = (activationID) => {
        setReleaseLockLoading(activationID);
        let request = {
            activationId: activationID
        }
        dispatch(releaseDailyPlanRequest(request));
    }

    const alertCancel = () => {
        setShowAlert(false);
        setAlertText('');
        setAlertType('');
        dispatch(resetMessage());
    }

    const displayAlert = (text, type) => {
        setAlertText(text);
        setAlertType(type);
        setShowAlert(true);
        dispatch(resetMessage());
    };

    const columns = [
        { displayName: '#', key: 'key' },
        { displayName: 'TRANSACTION ID', key: 'transactionID' },
        { displayName: 'SERIAL NUMBER', key: 'serialNumber' },
        { displayName: 'LOCKED DATE', key: 'createdDate' },
        { displayName: 'LOCKED BY', key: 'lockedBy' },
        { displayName: 'ACTION', key: 'action' },
    ];
    const filteredItems = Array.isArray(lockedDailyPlanResult) && lockedDailyPlanResult.length > 0 ? lockedDailyPlanResult.filter(item => {
        if (typeof filterText !== 'string' || typeof item !== 'object') return false;
        return Object.values(item).some(value => typeof value === 'string' && value.toLowerCase().includes(filterText.toLowerCase()));
    }) : [];


    var dataSource = filteredItems && filteredItems.length > 0 && filteredItems.map((item, key) => {
        return {
            key: key + 1,
            transactionID: item.TransactionID,
            serialNumber: item.SerialNumber,
            lockedBy: item.LockedBy,
            createdDate: convertDateToRequiredFormatTZ(item.CreatedDate),
            action: (
                releaselockloading === item.ActivationID ? (<div style={{ marginTop: "5px" }} className="spinner-border spinner-border-sm" role="status"> <span className="sr-only">Loading...</span> </div>) : (
                    <div className="icon iq-action-icon-box rounded-circle bg-secondary" onClick={() => handleUnlockDailyPlan(item.ActivationID)} style={{ cursor: "pointer" }} >
                        <i className="ri-lock-unlock-line" style={{ color: '#fff' }}></i>
                    </div>
                )
            )

        }
    });


    return (
        <>
            {showAlert && <Alert type={alertType} text={alertText} closeBtn={alertCancel} />}
            <div className="col-md-3">
                <SearchBar onFilter={handleFilterChange} filterText={filterText} />
            </div>

            <Table columns={columns} loading={loading} data={dataSource} pagination={true} />

        </>
    )
}

export default DailyPlanRequest
